import React from 'react';
import './RadioButton.css';
const RadioButton = (props) => {
    return (React.createElement("div", { className: `pl-0 mb-15 flex items-center ${props.className ?? ''}`, style: props.style },
        React.createElement("input", { id: props.id, name: props.name, type: "radio", value: props.value ?? '', checked: props.selected ?? false, onChange: (e) => props.onChange(e.target.value), className: "custom-radio" }),
        React.createElement("label", { className: "form-label mb-0", htmlFor: props.id }, props.label)));
};
export default RadioButton;
